const DEFAULT_DESTINO = "Destino";
const DEFAULT_MOTORISTA_BASE = "Base";
const DEFAULT_PEDIDO_IMPORTADO = "Pedido importado";
const DEFAULT_PEDIDO_MANUAL = "Pedido manual";
const DEFAULT_DOC_PEDIDO = "Documento do pedido";
const DEFAULT_DOC_OPERACIONAL = "Documento da van";

export function getDestinoLabel(config) {
  const label = String(config?.destino_label || config?.destinoLabel || "").trim();
  return label || DEFAULT_DESTINO;
}

export function getMotoristaBaseLabel(config) {
  const label = String(config?.motorista_base_label || config?.motoristaBaseLabel || "").trim();
  return label || DEFAULT_MOTORISTA_BASE;
}

export function getPedidoImportadoLabel(config) {
  const label = String(config?.pedido_importado_label || config?.pedidoImportadoLabel || "").trim();
  return label || DEFAULT_PEDIDO_IMPORTADO;
}

export function getPedidoManualLabel(config) {
  const label = String(config?.pedido_manual_label || config?.pedidoManualLabel || "").trim();
  return label || DEFAULT_PEDIDO_MANUAL;
}

export function getDocumentoPedidoLabel(config) {
  const label = String(config?.documento_pedido_label || config?.documentoPedidoLabel || "").trim();
  return label || DEFAULT_DOC_PEDIDO;
}

export function getDocumentoOperacionalLabel(config) {
  const label = String(config?.documento_operacional_label || config?.documentoOperacionalLabel || "").trim();
  return label || DEFAULT_DOC_OPERACIONAL;
}

export function getIntegracaoNome(config) {
  return String(config?.integracao_nome || config?.integracaoNome || "").trim();
}

export function getPedidoOrigemLabel(config, origem) {
  const fonte = String(origem || "").trim().toLowerCase();
  if (!fonte || fonte === "manual") return getPedidoManualLabel(config);
  const integracao = getIntegracaoNome(config);
  if (integracao && (fonte === "embraer" || fonte === "integracao")) {
    return `${getPedidoImportadoLabel(config)} (${integracao})`;
  }
  return getPedidoImportadoLabel(config);
}

export function formatTrechoLabel(trecho, config) {
  const destino = getDestinoLabel(config);
  if (trecho === "ida") return `Residências → ${destino}`;
  if (trecho === "volta") return `${destino} → Residências`;
  return destino;
}

export function formatTrechoCurto(trecho, config) {
  const destino = getDestinoLabel(config);
  if (trecho === "ida") return `🏭 Ida → ${destino}`;
  if (trecho === "volta") return "🏠 Volta → Casa";
  return "—";
}

export function formatMotoristaResposta(resposta, config) {
  if (resposta === "1" || resposta === "pereira") return getMotoristaBaseLabel(config);
  if (resposta === "2" || resposta === "casa") return "Casa";
  return resposta || "—";
}
